import sortBy from 'sort-by';

import { addDate, parseYmd, startOf } from './date-utils';

/** How far out an assessment still counts as something to study for right now. */
const IMMINENT_WINDOW_DAYS = 14;

/** The next assessment close enough for a student to be studying for it, if there is one. */
export function getImminentAssessment(assessments) {
  const today = startOf(new Date(), 'day');
  const cutoff = addDate(today, { days: IMMINENT_WINDOW_DAYS });
  return (assessments || [])
    .filter(a => {
      // Undated assessments are common — the semester scope keeps them on the strength of
      // created_at — and there is nothing to count down to.
      const date = a?.date && parseYmd(a.date);
      return date && date >= today && date <= cutoff;
    })
    .sort(sortBy('date'))[0];
}

export function getAssessmentCountdownLabel({ date }) {
  const days = Math.round((parseYmd(date) - startOf(new Date(), 'day')) / (24 * 60 * 60 * 1000));
  if (days <= 0) return 'today';
  if (days === 1) return 'tomorrow';
  return `in ${days} days`;
}

export function getAssessmentOnlineCourseChapters(assessmentItems, ocChapters) {
  return (
    assessmentItems &&
    ocChapters
      ?.map(ch => {
        if (assessmentItems.some(i => i.item_type === 'OnlineCourseChapter' && i.item_id === ch.id)) {
          return ch;
        }
        const sections = ch.sections.filter(s =>
          assessmentItems.some(i => i.item_type === 'OnlineCourseSection' && i.item_id === s.id),
        );
        if (sections.length) return { ...ch, sections };
      })
      .filter(Boolean)
  );
}
